const Data = [
  {
    name: "Aaradhya Shukla",
    position: "LiGHT Head",
    imageUrl: "/assets/images/members/Heads25/AaradhyaShukla.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  },
  {
    name: "Vikash Siyak",
    position: "LiGHT Head",
    imageUrl: "/assets/images/members/Heads25/VikashSiyak.jpg",
    facebookLink: "",
    linkedinLink: "",
    email: ""
  }
];

export default Data;